/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {BsModalRef} from 'ngx-bootstrap/modal';
import template from './report-template-widget-modal.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-report-template-widget-modal',
  template
})
export class ReportTemplateWidgetModalComponent implements OnInit {
  components: any[] = [];
  selections: Record<string, any> = {};

  readonly onSaved = new Subject<Record<string, any>>();

  constructor(public bsModalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.components = this.components || [];
  }

  toggleSelection(component: any): void {
    if (this.selections[component.id]) {
      delete this.selections[component.id];
    } else {
      this.selections[component.id] = component;
    }
  }

  save(): void {
    this.onSaved.next(this.selections);
    this.bsModalRef.hide();
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  isSelected(component: any): boolean {
    return !!this.selections[component.id];
  }

  trackById(_index: number, component: any): string {
    return component.id;
  }
}
